import { Subscription } from 'rxjs';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SuprimentosService } from 'src/app/services/suprimentos/suprimentos.service';
import { IToken } from 'src/app/interfaces/token/IToken';
import { AuthenticationService } from 'src/app/services';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { ISuprimentosChamado } from 'src/app/interfaces/suprimentos';
import { ListaPaginada } from 'src/app/models';
import { FiltroGenericoComponent } from 'src/app/components/filtro-generico/filtro-generico.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-suprimentos-historico-de-pedidos-entregue',
  templateUrl: './suprimentos-historico-de-pedidos-entregue.component.html',
  styleUrls: ['./suprimentos-historico-de-pedidos-entregue.component.scss']
})
export class SuprimentosHistoricoDePedidosEntregueComponent implements OnInit {
  @ViewChild(FiltroGenericoComponent) filtroGenerico: FiltroGenericoComponent;
  filtraForm!: FormGroup;
  subscriptions$ = new Subscription();
  suprimentos = new ListaPaginada<ISuprimentosChamado>();
  permissoes: IToken;
  autorizacoes: IAutorizacoes;
  filterData: any;
  token = this.authService.obterToken();
  // Permissoes

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authService.obterToken()['autorizacoes'];
  }

  constructor(
    private fb: FormBuilder,
    private service: SuprimentosService,
    private authService: AuthenticationService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  ngOnInit() {
    this.getUserPermissoes();
    this.filtraForm = this.fb.group({
      FiltroPesquisar: ['']
    });
    this.getPedidosSuprimentos();
    this.gerenciarPermissoesTela();
  }

  receiveFilterData(filterData: any) {
    this.filterData = filterData;
  }

  getPedidosSuprimentos(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.suprimentos.paginaAtual = 1;
    }

    this.filtroGenerico?.getFilterData();
    this.filtroGenerico?.hidePopUp();

    this.subscriptions$.add(
      this.service
        .getSuprimentosChamado({
          idUsuario: this.permissoes.id,
          pesquisar: this.filtraForm.get('FiltroPesquisar')?.value,
          numPatrimonio: this.filterData?.NumPatrimonio ?? '',
          numSerie: this.filterData?.NumSerie ?? '',
          CodContrato: this.filterData?.CodContrato ?? this.token.codContrato,
          CodGrupoEconomico: this.permissoes.codGrupoEconomico,
          paginaAtual: this.suprimentos.paginaAtual,
          entregue: true,
          itensPorPagina: this.suprimentos.itensPorPagina
        })
        .subscribe({
          next: ({ data }) => {
            this.suprimentos = data;
          }
        })
    );
  }

  getUserPermissoes() {
    this.permissoes = this.authService.obterToken();
    this.autorizacoes = this.permissoes.autorizacoes;
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
